export class InventoryDimensionReferenceModel {
    public inventoryDimensionCode: string;
    public inventoryDimensionName: string;
    public sortSequence: number;
}